import { EventInput } from '@fullcalendar/core';
import { CalendarEventModel } from '../../../../../../api-service/clients';

export const READONLY_EVENT_COLOR = '#3788d8';

export function createRandomCalendarEventId(): string {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID();
  }

  return `calendar-event-${Math.random().toString(36).slice(2, 12)}`;
}

export function parseEventDate(value?: Date | string): Date | undefined {
  if (!value) {
    return undefined;
  }

  const parsedDate = new Date(value);
  return Number.isNaN(parsedDate.getTime()) ? undefined : parsedDate;
}

export function createBaseCalendarEventInput(
  event: CalendarEventModel
): EventInput {
  return {
    id: createRandomCalendarEventId(),
    title: event.title,
    allDay: event.allDay,
    draggable: false,
    editable: false,
    resizable: false,
    backgroundColor: READONLY_EVENT_COLOR,
    borderColor: READONLY_EVENT_COLOR,
    textColor: '#ffffff',
    extendedProps: {
      type: event.type,
    },
  };
}
